export default "__VITE_ASSET__peN5TJSv__"